import { render, staticRenderFns } from "./templatemessage-add-and-update.vue?vue&type=template&id=02cbeb1d&scoped=true"
import script from "./templatemessage-add-and-update.vue?vue&type=script&lang=js"
export * from "./templatemessage-add-and-update.vue?vue&type=script&lang=js"
import style0 from "./templatemessage-add-and-update.vue?vue&type=style&index=0&id=02cbeb1d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cbeb1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02cbeb1d')) {
      api.createRecord('02cbeb1d', component.options)
    } else {
      api.reload('02cbeb1d', component.options)
    }
    module.hot.accept("./templatemessage-add-and-update.vue?vue&type=template&id=02cbeb1d&scoped=true", function () {
      api.rerender('02cbeb1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/templatemessage/templatemessage-add-and-update.vue"
export default component.exports